import React from "react";
import {TimbratureType} from "./TimbraturePLUS";
import css from "../pannelloGiornataPLUS.module.css"
import TooltipEx from "@components/Tooltip";
import {IconAlertCircleFilled, IconCalendarCheck, IconCopy, IconEdit, IconEraser, IconLock, IconLockOpen, IconX} from "@tabler/icons-react";

interface ButtonsTimbratureProps {
    tipoTimbrature: TimbratureType,

    locked: boolean,
    allineaCausali: () => void,
    onClickLock?: () => void,
    onClickCopy?: () => void,
    onClickClear?: () => void,

    isEffettiveOriginali?: boolean,

    editEffettive?: boolean,
    handleEditEffettive?: () => void,
    confirmEditEffettive?: () => void,
    closeEditEffettive?: () => void,
}

const ButtonsTimbrature: React.FC<ButtonsTimbratureProps>
    = ({
           locked, tipoTimbrature, allineaCausali, onClickLock, onClickCopy, onClickClear,
           isEffettiveOriginali, editEffettive, handleEditEffettive, confirmEditEffettive, closeEditEffettive
       }) => {
    const onToggleLock=()=>{
        if (onClickLock){
            allineaCausali();
            onClickLock();
        }
    }
    const onCopy=()=>{
        if (onClickCopy){
            allineaCausali();
            onClickCopy();
        }
    }
    const onClear=()=>{
        if (onClickClear){
            allineaCausali();
            onClickClear();
        }
    }

    const onConfirmEditEffettive=()=>{
        if (confirmEditEffettive){
            allineaCausali();
            confirmEditEffettive();
        }
    }
    return (
        <div className={css.containerBtnsTimbrature}>
            {(tipoTimbrature === 'previste' || tipoTimbrature === 'arrotondate') && <>
                <TooltipEx tooltip={locked ? 'Sblocca timbrature' : 'Blocca timbrature'}>
                    <button className={css.btnsTimbrature} type="button" onClick={onToggleLock}>
                        {locked ? <IconLock className={css.iconClass}/> : <IconLockOpen className={css.iconClass}/>}
                    </button>
                </TooltipEx>

                <TooltipEx tooltip={`Copia dalle ${tipoTimbrature === 'previste' ? 'arrotondate' : 'previste'}`}>
                    <button className={css.btnsTimbrature} type="button" onClick={onCopy}>
                        <IconCopy className={css.iconClass}/>
                    </button>
                </TooltipEx>

                <TooltipEx tooltip={`Pulisci ${tipoTimbrature === 'previste' ? 'previste' : 'arrotondate'}`}>
                    <button className={css.btnsTimbrature} type="button" onClick={onClear}>
                        <IconEraser className={css.iconClass}/>
                    </button>
                </TooltipEx>
            </>}

            {tipoTimbrature === 'effettive' && <div className="inline-flex">
                <TooltipEx tooltip="Riordina timbrature">
                    <button className={css.btnsTimbrature} type="button" onClick={handleEditEffettive}>
                        <IconEdit className={css.iconClass}/>
                    </button>
                </TooltipEx>
                {!isEffettiveOriginali && <IconAlertCircleFilled className="h-[18px] w-[18px] my-auto text-warning ml-2"/>}
            </div>}

            {tipoTimbrature === 'effettiveOriginali' && editEffettive && <>
                <TooltipEx tooltip="Consolida le timbrature">
                    <button className={css.btnsTimbrature} type="button" onClick={onConfirmEditEffettive}>
                        <IconCalendarCheck className={css.iconClass}/>
                    </button>
                </TooltipEx>
                <TooltipEx tooltip="Annulla riordino timbrature">
                    <button className={css.btnsTimbrature} type="button" onClick={closeEditEffettive}>
                        <IconX className={css.iconClass}/>
                    </button>
                </TooltipEx>
                {/*-{!checkEffettive ? 'true' : 'false'}-*/}
                {/*{(maskEffettive && maskEffettive !== 65535) ? 'true' : 'false'}*/}
            </>}

        </div>
    )
}
export default ButtonsTimbrature;